class FloatingDuoBtn extends HTMLElement {
  constructor() {
    super();

    this.onScroll = this.onScroll.bind(this);
    this.btn = null;
    this.triggerOffset = 30; 
  }

  connectedCallback() {
    this.btn = this.querySelector(".floating-duo-btn");
    if (!this.btn) return;

    window.addEventListener("scroll", this.onScroll);

    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll() {
    const scrollY = window.scrollY;

    if (scrollY > this.triggerOffset) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.btn.classList.add("floating-duo-btn--visible");
  }

  hide() {
    this.btn.classList.remove("floating-duo-btn--visible");
  }
}

customElements.define("floating-duo-btn", FloatingDuoBtn);
